import { LoadableLazy } from '@confluence/loadable';

export const NonMasteredUserModalLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-NonMasteredUserModal" */ './NonMasteredUserModal.tsx'
			)
		).NonMasteredUserModal,
});
